import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;
const AREA_DAF = API_URL + "/daf/";

const VMIDRECORD_BASE_URL = AREA_DAF + "VmidRecord/";
const VMIDRECORD_LIST_URL = VMIDRECORD_BASE_URL + "GetList";
const VMIDRECORD_ACQUIRERVMID_LIST_URL =
  VMIDRECORD_BASE_URL + "GetAcquirerVmidList";
const VMIDRECORD_SAVE_URL = VMIDRECORD_BASE_URL + "Save";
const VMIDRECORD_DOWNLOADVMIDPARAMETERSFILE_URL =
  VMIDRECORD_BASE_URL + "DownloadVmidParametersFile";

const VMIDRECORD_DOWNLOADACQUIRERVMIDPARAMETERSFILE_URL =
  VMIDRECORD_BASE_URL + "DownloadAcquirerVmidParametersFile";

const VMIDRECORD_DOWNLOADPARTICIPATIONFILE_URL =
  VMIDRECORD_BASE_URL + "DownloadVmidParticipationFile";

export const DafVmidApi = {
  getVmidList,
  getAcquirerVmidList,
  saveVmid,
  downloadVmidParametersFile,
  downloadAcquirerVmidParametersFile,
  downloadVmidParticipationFile,
};

function getVmidList(skipCount, sorting, dsc, searchVal) {
  let data = prepareFilterParams(skipCount, sorting, dsc, searchVal);
  return axios.post(VMIDRECORD_LIST_URL, data);
}

function getAcquirerVmidList(skipCount, sorting, dsc, searchVal) {
  let data = prepareFilterParams(skipCount, sorting, dsc, searchVal);
  return axios.post(VMIDRECORD_ACQUIRERVMID_LIST_URL, data);
}

function prepareFilterParams(
  skipCount = 0,
  sorting = null,
  dsc = false,
  searchVal = null
) {
  if (dsc) {
    sorting += " desc";
  }

  let data = {
    skipCount: skipCount,
    sorting: sorting,
    searchVal: searchVal,
  };

  return data;
}

function saveVmid(data) {
  return axios.post(VMIDRECORD_SAVE_URL, data);
}

function downloadVmidParametersFile() {
  return axios.get(VMIDRECORD_DOWNLOADVMIDPARAMETERSFILE_URL, {
    responseType: "blob",
  });
}

function downloadAcquirerVmidParametersFile() {
  return axios.get(VMIDRECORD_DOWNLOADACQUIRERVMIDPARAMETERSFILE_URL, {
    responseType: "blob",
  });
}

function downloadVmidParticipationFile() {
  return axios.get(VMIDRECORD_DOWNLOADPARTICIPATIONFILE_URL, {
    responseType: "blob",
  });
}
